module.exports = __webpack_public_path__ + "img/sm-line.e45f5ff7.svg";